import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { IdentityProvidersTableProps } from 'pages/Settings/IdentityProvidersPage/IdentityProviders';
import { updateIdentityProvider } from 'utils/identity_providers';

const errorMessage = 'Unable to save Identity Provider.';

const maxIdentityProviderNameLength = 100;

export function IdentityProviderNameCell({
    rowData,
    onChange,
}: IdentityProvidersTableProps) {
    const onSave = async (newValue: string | undefined) => {
        if (!newValue) {
            return errorMessage;
        }
        try {
            await updateIdentityProvider(rowData, { Name: newValue });
            onChange();
        } catch {
            return errorMessage;
        }
        return undefined;
    };
    return (
        <TextInlineEditor
            onConfirm={onSave}
            value={rowData.Name}
            validate={(value) => {
                if (!value) {
                    return 'Identity Provider name is required';
                }
                if (value.length > maxIdentityProviderNameLength) {
                    return 'Identity Provider name is too long';
                }
                return undefined;
            }}
        />
    );
}
